/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TITLE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	title: {
		marginBottom: pxToEm(10),
		textAlign: 'center',
		textTransform: 'capitalize',
		'& h2, h3, h4, h5': {
			fontSize: pxToEm(18),
			fontWeight: '600',
			lineHeight: '1'
		},
		'& .points':{
			marginTop: pxToEm(5)
		}
	}
};